import React from 'react';

const TicketSVG = () => (
  <svg
    height="1em"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.65186 1.76807C6.65186 1.35385 6.98764 1.01807 7.40186 1.01807H13.0891C13.0891 1.01807 13.5312 4.16809 16.7717 4.16809C20.0121 4.16809 20.4542 1.01807 20.4542 1.01807H26.1486C26.5629 1.01807 26.8986 1.35385 26.8986 1.76807V30.1535C26.8986 30.5677 26.5629 30.9035 26.1486 30.9035H20.4542C20.4542 30.9035 20.2939 27.7563 16.744 27.7563C13.0891 27.7563 13.0891 30.9035 13.0891 30.9035H7.40186C6.98764 30.9035 6.65186 30.5677 6.65186 30.1535V1.76807Z"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M6.68448 8.86711H27.0003" stroke="currentColor" strokeWidth="2" />
    <path
      d="M9.87422 15.1711H23.6187"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M11.0468 19.9025H22.4589"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default TicketSVG;
